import CardImageTouch1 from "@/assets/products/card/touch-1.png";
import CardImageClimate1 from "@/assets/products/card/climate-1.jpg";
import CardImageUltra1 from "@/assets/products/card/sonic-1.jpg";
import CardImageChargeC1 from "@/assets/products/card/charge-c1.jpg";
import CardImagePowerC1 from "@/assets/products/card/power-c1.jpg";
import CardImageLEDW1 from "@/assets/products/card/led-w1.jpeg";

import PageImageTouch11 from "@/assets/products/pages/Touch1/0.jpg";
import PageImageTouch12 from "@/assets/products/pages/Touch1/1.jpg";

import PageImageClimate11 from "@/assets/products/pages/Climate1/0.jpg";
import PageImageClimate12 from "@/assets/products/pages/Climate1/1.jpg";

import PageImageUltra11 from "@/assets/products/pages/Ultra1/0.jpg";
import PageImageUltra12 from "@/assets/products/pages/Ultra1/1.jpg";

import PageImageChargeC11 from "@/assets/products/pages/ChargeC1/0.jpg";
import PageImageChargeC12 from "@/assets/products/pages/ChargeC1/1.jpg";

import PageImagePowerC11 from "@/assets/products/pages/PowerC1/0.jpg";
import PageImagePowerC12 from "@/assets/products/pages/PowerC1/1.jpg";

import PageImageLEDW11 from "@/assets/products/pages/LEDW1/0.jpg";
import PageImageLEDW12 from "@/assets/products/pages/LEDW1/1.jpg";

import PageImageLastImage from "@/assets/products/pages/Qubee_End.jpg";

export interface ProductShowcaseType {
    name: string;
    image: string;
    description: string;
    url: string;
};

export const AllProducts: ProductShowcaseType[] = [
  {
    name: "LED W1",
    image: CardImageLEDW1,
    description: "WS2812 based addresable RGB LED",
    url: "/led-w1",
  },
  {
    name: "Power C1",
    image: CardImagePowerC1,
    description: "Li-Ion battery charger with builtin 5V boost convertor",
    url: "/power-c1",
  },
  {
    name: "Touch 1",
    image: CardImageTouch1,
    description: "TTP223 based Touch Sensor",
    url: "/touch1",
  },
  {
    name: "Climate 1",
    image: CardImageClimate1,
    description: "DHT11 based Temperature & Humidity Sensor",
    url: "/climate1",
  },
  {
    name: "Charge C1",
    image: CardImageChargeC1,
    description: "TP4056 based Li-Ion battery charger",
    url: "/charge-c1",
  },
  {
    name: "Ultra 1",
    image: CardImageUltra1,
    description: "HC-SR04 based Ultrasonic Sensor",
    url: "/ultra1",
  },
];

export const NewlyLaunchedProducts: ProductShowcaseType[] = [
  {
    name: "LED W1",
    image: CardImageLEDW1,
    description: "WS2812 based addresable RGB LED",
    url: "/led-w1",
  },
  {
    name: "Power C1",
    image: CardImagePowerC1,
    description: "Li-Ion battery charger with builtin 5V boost convertor",
    url: "/power-c1",
  },
  {
    name: "Touch 1",
    image: CardImageTouch1,
    description: "TTP223 based Touch Sensor",
    url: "/touch1",
  },
  {
    name: "Climate 1",
    image: CardImageClimate1,
    description: "DHT11 based Temperature & Humidity Sensor",
    url: "/climate1",
  },
];

export interface ProductData {
  title: string;
  price: string;
  description: string;
  images: string[];
  buyLinks: { name: string; url: string; }[];
  datas: { name: string; description: string; }[];
}

export const Touch1: ProductData = {
  title: "Touch 1",
  price: "99",
  description: "Touch 1 is a TTP223 based touch key. The touching detection IC is designed for replacing traditional direct button key with diverse pad size. Low power consumption and wide operating voltage are the contact key features for DC or AC application.",
  buyLinks: [
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-touch-1-ttp223-sensor-electronic-components-hobby-kit/p/itma8088f47d48aa",
    },
  ],
  datas: [
    { name: "IC", description: "TTP223" },
    { name: "Input Voltage", description: "2 Volt – 5.5 Volts DC" },
    { name: "Max Response Time (Fast Mode)", description: "60 ms" },
    { name: "Max Response Time (Slow Mode)", description: "220 ms" },
    { name: "Toggle Option", description: "Provides direct toggle mode by pad option(TOG pin)" },
    { name: "Calibration/Recalibration", description: "Automatic" },
    { name: "What's in the box?", description: "4 x Touch 1 (Pack of 4 variant)" }
  ],
  images: [
    PageImageTouch11,
    PageImageTouch12,
    PageImageLastImage,
  ],
};

export const Climate1: ProductData = {
  title: "Climate 1",
  price: "299",
  description: "Climate 1 (DHT11) Temperature And Humidity Sensor Module with LED is a small humidity and temperature sensor that you can connect to your Arduino and get readings for temperature and humidity in the environment.",
  buyLinks: [
    {
      name: "Meesho",
      url: "https://www.meesho.com/climate-1-dht11-temperature-and-humidity-sensor/p/alalwu",
    },
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-climate-1-dht11-temperature-humidity-sensor-electronic-components-hobby-kit/p/itm8361a115731cf",
    },
  ],
  datas: [
    { name: "IC", description: "DHT11" },
    { name: "Input Voltage", description: "3.3 Volt – 5 Volts DC" },
    { name: "Supply Current", description: "0.3mA / standby 60μA" },
    { name: "Temperature measurement range", description: "0C ~ 50C degrees" },
    { name: "Temperature measurement error", description: "±2 degrees" },
    { name: "Humidity measurement range", description: "20% ~ 95% RH" },
    { name: "Humidity measurement error", description: "±5% RH" },
    { name: "What's in the box?", description: "1 x Climate 1, 1 x 3-Pin Female to Female header cable" }
  ],
  images: [
    PageImageClimate11,
    PageImageClimate12,
    PageImageLastImage,
  ],
};

export const Ultra1: ProductData = {
  title: "Ultra 1",
  price: "399",
  description: "Ultra 1 Module based on HC-SR04 provides highly accurate non-contact distance sensing capabilities using ultrasonic sound, Ranging accuracy up to 3mm.",
  buyLinks: [
    {
      name: "Meesho",
      url: "https://www.meesho.com/qubee-ultra-1-hc-sr04-ultrasonic-sensor/p/auz3r8",
    },
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-ultra-1-hc-sr04-ultrasonic-sensor-electronic-components-hobby-kit/p/itm60de2fa0af803",
    },
  ],
  datas: [
    { name: "Based On", description: "HC-SR04" },
    { name: "Input Voltage", description: "4.5 Volt – 5.5 Volts DC" },
    { name: "Sensing Range", description: "upto 450 cm" },
    { name: "Operating Frequency", description: "40 khz" },
    { name: "What's in the box?", description: "1 x Ultra 1" }
  ],
  images: [
    PageImageUltra11,
    PageImageUltra12,
    PageImageLastImage,
  ],
};

export const ChargeC1: ProductData = {
  title: "Charge C1",
  price: "199",
  description: "Charge C1 Module based on TP4056 IC, is a highly efficient Type-C Li-Ion battery charging module with DW01 Over-discharge, Over-charge and Over-current protection IC. It comes with two status led for showing charging/discharging status.",
  buyLinks: [
    {
      name: "Meesho",
      url: "https://www.meesho.com/charge-c1-tp4056-charging-module-pack-of-2/p/auyqac",
    },
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-charge-c1-tp4056-type-c-charging-module-pack-2-electronic-components-hobby-kit/p/itm76505fd826dd2",
    },
  ],
  datas: [
    { name: "Based On", description: "TP4056 & DW01" },
    { name: "Input Voltage", description: "5 - 5.5 Volts DC (Type-C/Input Terminals)" },
    { name: "Status LEDs", description: "Red fo Charging, Blue for Charged" },
    { name: "Charging current", description: "upto 1A" },
    { name: "Max power consumption", description: "5W ±5%" },
    { name: "Battery type supported", description: "Li-Ion" },
    { name: "Over-current Protection", description: "Yes" },
    { name: "Over-charge Protection", description: "Yes" },
    { name: "Over-discharge Protection", description: "Yes" },
    { name: "What's in the box?", description: "2 x Charge C1 (Pack of 2 variant)" },
  ],
  images: [
    PageImageChargeC11,
    PageImageChargeC12,
    PageImageLastImage,
  ],
};

export const PowerC1: ProductData = {
  title: "Power C1",
  price: "499",
  description: "Power C1 Module, based on the FM5324HJ1 IC, is a highly efficient Type-C Li-Ion battery charging module with a built-in 5V boost converter. It features over-current, over-charging, and over-discharging protection. The module includes four status LEDs and an onboard female USB Type-A port. It also provides an option to connect an external key for toggling power on/off, along with easily accessible 5V pads.",
  buyLinks: [
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-power-c1-li-ion-battery-charger-boost-convertor-5v-2a-pack-2-electronic-components-hobby-kit/p/itm45de2f1406540",
    }
  ],
  datas: [
    { name: "Based On", description: "FM5324HJ1" },
    { name: "Input Voltage", description: "5 - 5.5 Volts DC (Type-C)" },
    { name: "Status LEDs", description: "4 - Shows levels of battery charging/charge left" },
    { name: "Charging Current", description: "upto 2.4A" },
    { name: "Output Current", description: "upto 2A" },
    { name: "Auto Shutdown", description: "Yes for load <50mA" },
    { name: "Over-current Protection", description: "Yes" },
    { name: "Over-charge Protection", description: "Yes" },
    { name: "Over-discharge Protection", description: "Yes" },
    { name: "Efficiency", description: "~92.5%" },
    { name: "Standby Current", description: "30uA" },
    { name: "What's in the box?", description: "2 x Power C1 (Pack of 2 variant)" },
  ],
  images: [
    PageImagePowerC11,
    PageImagePowerC12,
    PageImageLastImage,
  ],
};

export const LEDW1: ProductData = {
  title: "LED W1",
  price: "199",
  description: "LED W1 Module, based on the WS2812 RGB LED, is a compact addressable LED breakout board with an integrated WS2811B driver. It allows independent control of color and brightness, making it ideal for creating custom displays or addressable LED strings. The module features 0.1″ spaced headers for easy breadboard use and supports daisy-chaining multiple modules together.",
  buyLinks: [
    {
      name: "Meesho",
      url: "www.meesho.com/led-w1-ws2812-rgb-led-pack-of-2-led-module/p/auz1z8",
    },
    {
      name: "Flipkart",
      url: "https://www.flipkart.com/qubee-led-w1-ws2812-rgb-pack-2-module-electronic-hobby-kit/p/itm3e3103c933357",
    },
  ],
  datas: [
    { name: "Based On", description: "WS2812 (with WS2811B driver)" },
    { name: "Operating Voltage", description: "5 Volts DC" },
    { name: "Brightness Levels", description: "256 per color channel (16M colors)" },
    { name: "Signal Type", description: "Single-wire digital data" },
    { name: "Data Speed", description: "upto 800 Kbps" },
    { name: "Reshaping Circuit", description: "Built-in signal reshaping ensures reliable cascading" },
    { name: "Reset Circuits", description: "Built-in power-on and brown-out reset" },
    { name: "Scan Frequency", description: "≥400 Hz/s" },
    { name: "Cascading Support", description: "Up to 1024 LEDs at 30 FPS refresh rate" },
    { name: "Transmission Distance", description: "Up to 5m between two LEDs without amplifier" },
    { name: "Color Consistency", description: "High uniformity across LEDs" },
    { name: "Application", description: "Decorative lighting, LED strips, displays, indoor/outdoor LED screens" },
    { name: "What's in the box?", description: "2 x LED W1 (Pack of 2 variant)" },
  ],
  images: [
    PageImageLEDW11,
    PageImageLEDW12,
    PageImageLastImage,
  ]
};
